import axios, { AxiosError } from "axios";
// eslint-disable-next-line import/no-named-as-default
import i18n from "i18next";

const BASE_URL = process.env.REACT_APP_API_HOST as string;

async function handleAxiosError(err: AxiosError) {
  // TODO : handle all error
  return err?.response;
}

const create = () => {
  const axiosClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      locale: i18n.language,
      "platform-id": 1,
    },
  });

  axiosClient.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (err: AxiosError) => {
      return handleAxiosError(err);
    }
  );
  axiosClient.interceptors.request.use((config) => {
    config.params = config.params || {};
    return config;
  });
  return axiosClient;
};

const api = () => create();

export default api;
